import { useContext, useState } from "react";
import css from "../Food.module.css";
import Intro from "../../../components/intro/Intro";
import NotificationsContext from "../../../context/notifications";
import Steps from "../Steps";
import Clickard from "../../../components/Clickard/Clickard";
import Note from "../../../components/note/Note";

const Pancakes = () => {
  const { addNotification } = useContext(NotificationsContext);

  const [variant, setVariant] = useState("plain");

  return (
    <>
      <Intro
        primary="PANCAKES"
        secondary={`You'll need 30 minutes (15 to prepare, 15 to make), ${["banana", "blueberry"].includes(variant) ? 9 : 8} ingredients, and ${["banana", "blueberry"].includes(variant) ? 8 : 7} tools. They're surprisingly light, fluffy, and delicious for how easy they are. You should end up with ~4 medium-sized pancakes.`}
        tertiary="Enjoy!"
      />
      <div className="column p01 g1">
        <h2>1. CUSTOMIZE</h2>

        <fieldset className="columns_3">
          <button
            className={`${css.pancake_plain} ${
              variant === "plain" ? css.selected : ""
            }`}
            onClick={() => {
              setVariant("plain");
            }}
          >
            PLAIN
          </button>
          <button
            className={`${css.pancake_variant} ${css.pancake_banana} ${
              variant === "banana" ? css.selected : ""
            }`}
            onClick={() => {
              setVariant("banana");
            }}
          >
            BANANA
          </button>
          <button
            className={`${css.pancake_variant} ${css.pancake_blueberry} ${
              variant === "blueberry" ? css.selected : ""
            }`}
            onClick={() => {
              setVariant("blueberry");
            }}
          >
            BLUEBERRY
          </button>
        </fieldset>

        <h2>2. PREPARE</h2>
        <div className="columns_2">
          <div className={css.instruction}>
            <strong className="ctext">INGREDIENTS</strong>
            <div className="flex between">
              <span className="white">baking powder</span>½ tablespoon
            </div>
            {variant === "banana" && (
              <div className="flex between">
                <span className="white">banana</span>1
              </div>
            )}
            {variant === "blueberry" && (
              <div className="flex between">
                <span className="white">blueberries</span>
                28
              </div>
            )}
            <div className="flex between">
              <span className="white">butter</span>2 tablespoons
            </div>
            <div className="flex between">
              <span className="white">butter</span>
              (for the pan)
            </div>
            <div className="flex between">
              <span className="white">egg</span>1
            </div>
            <div className="flex between">
              <span className="white">flour (all-purpose)</span>1 cup
            </div>
            <div className="flex between">
              <span className="white">milk</span>1 cup
            </div>
            <div className="flex between">
              <span className="white">salt</span>1 pinch
            </div>
            <div className="flex between">
              <span className="white">sugar</span>½ tablespoon
            </div>
          </div>

          <div className={css.instruction}>
            <strong className="ctext">TOOLS</strong>
            <div className="flex between">
              <span className="underline">½ tablespoon</span>1
            </div>
            <div className="flex between">
              <span className="underline">1 cup</span>1
            </div>
            <div className="flex between">
              <span className="underline">bowl (large)</span>1
            </div>
            <div className="flex between">
              <span className="underline">pan</span>1
            </div>
            <div className="flex between">
              <span className="underline">butter knife</span>1
            </div>
            {["banana", "blueberry"].includes(variant) && (
              <div className="flex between">
                <span className="underline">sharp knife</span>1
              </div>
            )}
            <div className="flex between">
              <span className="underline">spatula</span>1
            </div>
            <div className="flex between">
              <span className="underline">stove</span>1
            </div>
          </div>
        </div>

        <h2>3. COOK</h2>

        <div className="column g1">
          <Steps>
            <p>
              Add to the <span className="underline">bowl</span>...
            </p>
            <ul className={css.bullets}>
              <li className="flex between">
                <span className="white">baking powder</span>½ tablespoon
              </li>
              <li className="flex between">
                <span className="white">flour</span>1 cup
              </li>
              <li className="flex between">
                <span className="white">salt</span>1 pinch
              </li>
              <li className="flex between">
                <span className="white">sugar</span>½ tablespoon
              </li>
            </ul>
            <p>
              ...then mix together with the{" "}
              <span className="underline">spatula</span>.
            </p>
          </Steps>

          <Note type="success">
            <p>
              You've made <span className="white">pancake mix</span>. This can
              be stored indefinitely.
            </p>
          </Note>

          <Steps>
            <p>
              Add to the <span className="underline">bowl</span>...
            </p>
            <ul className={css.bullets}>
              <li className="flex between">
                <span className="white">milk</span>1 cup
              </li>
              <li className="flex between">
                <span className="white">egg</span>1
              </li>
            </ul>
            <p>
              ...then mix together with the{" "}
              <span className="underline">butter knife</span> until the{" "}
              <span className="white">egg</span> is broken up and the{" "}
              <span className="white">pancake mix</span> is wet.
            </p>
          </Steps>

          <Steps>
            <p>
              Put the <span className="underline">pan</span> on the{" "}
              <span className="underline">stove</span> and set the heat to
              medium-low.
            </p>
            <p>
              Add <span className="white">butter</span> (2 tablespoons) to the{" "}
              <span className="underline">pan</span>.
            </p>
          </Steps>

          {["banana", "blueberry"].includes(variant) && (
            <>
              <p className="ctext">
                While the <span className="underline">pan</span> is heating
                up...
              </p>

              <Steps>
                {variant === "banana" && (
                  <p>
                    Use the <span>sharp knife</span> to cut 28 thin slices from
                    the <span>banana</span>.
                  </p>
                )}
                {variant === "blueberry" && (
                  <p>
                    Use the <span>sharp knife</span> to cut the{" "}
                    <span>blueberries</span> (28) in half.
                  </p>
                )}
              </Steps>
            </>
          )}
          <p className="ctext">
            Wait for the <span className="white">butter</span> to melt.
          </p>
          <Steps>
            <p>
              Add the <span className="white">melted butter</span> to the{" "}
              <span className="underline">bowl</span>...
            </p>
            <p>
              ...then mix together with the the{" "}
              <span className="underline">butter knife</span>.
            </p>
          </Steps>
        </div>
      </div>

      <div className={css.repeat}>
        <h3 className="ctext">REPEAT THE FOLLOWING</h3>
        <Steps>
          <p>
            Add just enough <span className="white">butter</span> to coat the
            bottom of the <span className="underline">pan</span>...
          </p>
          <p>
            ...then use the <span className="underline">1 cup</span> to add as
            much <span className="white">pancake batter</span> as you want to
            the <span className="underline">pan</span>.
          </p>
          {variant === "banana" && (
            <p>
              Add <span>banana slices</span> (7) to the{" "}
              <span>pancake batter</span>.
            </p>
          )}
          {variant === "blueberry" && (
            <p>
              Add <span>blueberry halves</span> (14) to the{" "}
              <span>pancake batter</span>.
            </p>
          )}
        </Steps>
        <p className="ctext">
          Wait for the <span className="white">pancake batter</span> to cook
          until the bottom is golden brown.
        </p>
        <Note type="info">
          Signs that it's time: bubbles appear in the center and the edges cook
          through.
        </Note>
        <Steps>
          <p>
            Use the <span className="underline">spatula</span> to flip the
            half-cooked pancake over.
          </p>
        </Steps>
        <p className="ctext">
          Wait for the half-cooked pancake to cook until the bottom (top?) is
          golden brown.
        </p>
        <Steps>
          <p>
            Use the <span className="underline">spatula</span> to remove the{" "}
            <span className="white">pancake</span> from the{" "}
            <span className="underline">pan</span>.
          </p>
        </Steps>
      </div>

      <div className="column p01 g1">
        <button
          className="button"
          onClick={() =>
            addNotification({
              primary: "NICE WORK!",
              secondary: "You did it! Enjoy!",
              type: "success",
              showTime: 4,
            })
          }
        >
          CELEBRATE!
        </button>
        <h2 style={{ marginTop: "3rem" }}>MORE TO COOK</h2>
        <div className="columns_3">
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/banana_bread/loaf_2x1.jpg",
              alt: "banana bread",
            }}
            link="/cookbook/banana-bread"
            text="Banana Bread"
          />
          <Clickard
            img={{
              src: "https://storage.googleapis.com/squidslippers-media/food/popcorn.jpg",
              alt: "popcorn",
            }}
            link="/cookbook/popcorn"
            text="Popcorn"
          />
        </div>
      </div>
    </>
  );
};

export default Pancakes;
